import React from 'react';
import BarChart from '.././../containers/Charts/BarChart';
import LineChart from '.././../containers/Charts/LineChart';
import FinancialInfo from './FinancialInfo/FinancialInfo';
import './StockDetails.css';


const StockIncome = ({income, aspect}) => {
    console.log(income?.timeBasedSheets[1]);
    const revenueData = {
        labels: income?.timeBasedSheets[1]?.columnHeadings,
        datasets: [
            {
                data: income?.timeBasedSheets[1]?.chartData[0]?.values,
                label: income?.timeBasedSheets[1]?.chartData[0]?.name,
                fill : true,
                backgroundColor: `#dd3b4698`,
                borderColor: `#f8303e`,
                barThickness: 50,
            }
        ]
    }

    const netData = {
        labels: income?.timeBasedSheets[1]?.columnHeadings,
        datasets: [
            {
                data: income?.timeBasedSheets[1]?.chartData[1]?.values,
                label: income?.timeBasedSheets[1]?.chartData[1]?.name,
                fill : true,
                backgroundColor: `#59d455a1`,
                borderColor: `#30a02cd2`,
                barThickness: 50,
            }
        ]
    }

    const profitData = {
            labels: income?.timeBasedSheets[1]?.columnHeadings,
            datasets: [
                {
                    data: income?.timeBasedSheets[1]?.chartData[2]?.values,
                    label: income?.timeBasedSheets[1]?.chartData[2]?.name,
                    fill : true,
                    backgroundColor: `#71d46d48`,
                    borderColor: `#30a02cd2`,
                    barThickness: 50,
                }
            ]
    }

    const barOptions = {
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },

                }
            ],
            y: {
                ticks: {
                    // Include a dollar sign in the ticks
                    callback: function(value, index, values) {
                        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumSignificantDigits: 3 }).format(value/10000000) + " Cr";
                        
                    }
                }
            }
        }
    }

    const lineOptions = {
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },

                }
            ],
        }
    }

    return (
        <div className="mt-4">
            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li className="nav-item btn-sm mx-2" role="presentation">
                    <button className="nav-link finance-link active" id="pills-iabout-tab" data-bs-toggle="pill" data-bs-target="#pills-iabout" type="button" role="tab" aria-controls="pills-iabout" aria-selected="true">
                        <small><small>About</small></small>
                    </button>
                </li>
                <li className="nav-item btn-sm mx-2" role="presentation">
                    <button className="nav-link finance-link" id="pills-revenue-tab" data-bs-toggle="pill" data-bs-target="#pills-revenue" type="button" role="tab" aria-controls="pills-revenue" aria-selected="false">
                        <small><small>Revenue</small></small>
                    </button>
                </li>
                <li className="nav-item btn-sm mx-2" role="presentation">
                    <button className="nav-link finance-link" id="pills-net-tab" data-bs-toggle="pill" data-bs-target="#pills-net" type="button" role="tab" aria-controls="pills-net" aria-selected="false">
                        <small> <small>Net Income</small> </small>
                    </button>
                </li>
                <li className="nav-item btn-sm mx-2" role="presentation">
                    <button className="nav-link finance-link" id="pills-profit-tab" data-bs-toggle="pill" data-bs-target="#pills-profit" type="button" role="tab" aria-controls="pills-profit" aria-selected="false">
                        <small><small>Profit Margin</small></small>
                    </button>
                </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="pills-iabout" role="tabpanel" aria-labelledby="pills-iabout-tab">
                    <FinancialInfo aspect={aspect}/>
                </div>
                <div className="tab-pane fade" id="pills-revenue" role="tabpanel" aria-labelledby="pills-revenue-tab">
                    <BarChart data={revenueData} options={barOptions}/>
                </div>
                <div className="tab-pane fade" id="pills-net" role="tabpanel" aria-labelledby="pills-net-tab">
                    <BarChart data={netData} options={barOptions}/>
                </div>
                <div className="tab-pane fade" id="pills-profit" role="tabpanel" aria-labelledby="pills-profit-tab">
                    <LineChart data={profitData} options={lineOptions}/>
                </div>
            </div>            
        </div>
    )
}

export default StockIncome
